(function(_){
    'use strict';
    _['FREE.KEY']='Page';
    _['FREE.NO-CONTENT'] = 'This module is empty';
}(translations['en']));












// WEBPACK FOOTER //
// ./src/app/modules/free/lang/free-lang_en.js